import Swiper from "./swiper-bundle.esm.browser.min.js";
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("#wt-announcement__container");
    this.announcementInterval = null;

    this.initSlider();

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
  }

  initSlider() {
    const swiperContainer = this.querySelector("[data-announcement-swiper]");

    if(swiperContainer) {
      const animationSpeed = parseInt(swiperContainer.getAttribute("data-animation-speed"));
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        loop: true,
        speed: animationSpeed,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }
}

customElements.define("announcement-bar", AnnouncementBar);
